import { Box, IconButton } from '@mui/material';
import { useFormikContext } from 'formik';
import { icons } from '../../config/DailyReportIcons';

const DailyReportIcons = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const handleIconClick = (iconName) => {
    let current = values.icon || [];

    if (current.includes(iconName)) {
      const updated = current.filter((i) => i !== iconName);
      setFieldValue('icon', updated);
      return;
    }

    if (current.length === 0) {
      setFieldValue('icon', [iconName]);
      return;
    }

    if (current.length === 1 && (current[0] === 'windy' || iconName === 'windy')) {
      setFieldValue('icon', [...current, iconName]);
      return;
    }

    return;
  };

  return (
    <Box display="flex" gap="0.5rem" flexWrap="wrap" justifyContent="center">
      {icons.map((icon) => (
        <IconButton
          key={icon.name}
          disabled={disabled}
          onClick={() => handleIconClick(icon.name)}
          sx={{
            border: values?.icon?.includes(icon.name) ? '2px solid #1976d2' : '2px solid transparent',
          }}
        >
          {icon.svg}
        </IconButton>
      ))}
    </Box>
  );
};

export default DailyReportIcons;
